import HttpService from '../common/http/HttpService';
import Endpoint from './Endpoint';

async function shouldShowLegacyAlarmMessage() {
  const response = await HttpService.get(Endpoint.SHOULD_SHOW_LEGACY_ALARM_MESSAGE);
  return response.data;
}

const FilterService = {
  shouldShowLegacyAlarmMessage,
};

export default FilterService;
